// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Page from "../../resources/layout-and-structure/Page.res.js";
import * as Group from "../../resources/layout-and-structure/Group.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as React from "react";
import * as Request from "../../core/Request.res.js";
import * as Notifier from "../../bundles/Notifier/Notifier.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as StockTransferForm from "../../modules/StockTransfer/StockTransferForm.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as StockTransferFormActions from "../../modules/StockTransfer/StockTransferFormActions.res.js";
import * as StockTransferFormProductsCard from "../../modules/StockTransfer/StockTransferFormProductsCard.res.js";
import * as StockTransferFormSenderInformationCard from "../../modules/StockTransfer/StockTransferFormSenderInformationCard.res.js";
import * as StockTransferFormRecipientInformationCard from "../../modules/StockTransfer/StockTransferFormRecipientInformationCard.res.js";

function StockTransferCreatePage(props) {
  let notifier = Notifier.use(undefined, undefined);
  let shops = Auth.useShops();
  let onSubmitFailure = React.useCallback(message => notifier.reset({
    TAG: "Error",
    _0: message
  }, undefined, undefined), []);
  let onSubmitSuccess = React.useCallback(submissionResponse => {
    if (submissionResponse !== undefined) {
      return notifier.clear();
    } else {
      return notifier.add({
        TAG: "Error",
        _0: Request.serverErrorMessage
      }, undefined, undefined);
    }
  }, []);
  let match = StockTransferForm.useFormPropState({
    initialValues: StockTransferForm.initialValues,
    schema: StockTransferForm.schema,
    resetValuesAfterSubmission: true,
    onSubmitFailure: onSubmitFailure,
    onSubmitSuccess: onSubmitSuccess
  });
  let formState = match[0];
  let productsRowErrors = StockTransferForm.productsError(formState.values.products);
  let oldFormStatus = React.useRef(formState.status);
  React.useEffect(() => {
    let match = formState.submission;
    if (typeof match === "object" && match.TAG === "Succeeded") {
      let match$1 = formState.values;
      let recipientShopId = match$1.recipientShopId;
      let senderShopId = match$1.senderShopId;
      let senderShop = Stdlib_Option.getExn(shops.find(shop => shop.id === senderShopId), undefined);
      let recipientShop = Stdlib_Option.getExn(shops.find(shop => shop.id === recipientShopId), undefined);
      let strLiteral = I18n.isPlural(formState.values.products.length) ? "All seized stocks were successfully transferred from {{sender}} to {{recipient}}!" : "The seized stock was successfully transferred from {{sender}} to {{recipient}}!";
      let notification = I18n.template(I18n.t(strLiteral), {
        sender: senderShop.name,
        recipient: recipientShop.name
      }, undefined);
      notifier.reset({
        TAG: "Success",
        _0: notification
      }, undefined, undefined);
    }
  }, [formState.submission]);
  React.useEffect(() => {
    if (oldFormStatus.current === "Pristine" && formState.status !== "Pristine") {
      notifier.clear();
    }
    oldFormStatus.current = formState.status;
  }, [formState.status]);
  return JsxRuntime.jsx(StockTransferForm.Core.Provider.make, {
    children: JsxRuntime.jsxs(Page.make, {
      children: [
        JsxRuntime.jsx(Notifier.Banner.make, {
          notifier: notifier
        }),
        JsxRuntime.jsx(Box.make, {
          children: JsxRuntime.jsxs(Stack.make, {
            children: [
              JsxRuntime.jsxs(Group.make, {
                children: [
                  JsxRuntime.jsx(StockTransferFormSenderInformationCard.make, {}),
                  JsxRuntime.jsx(StockTransferFormRecipientInformationCard.make, {})
                ],
                spaceX: "large"
              }),
              JsxRuntime.jsx(StockTransferFormProductsCard.make, {
                productsRowErrors: productsRowErrors
              })
            ],
            space: "medium"
          }),
          spaceTop: "medium"
        })
      ],
      title: I18n.t("Stock transfer"),
      renderActions: () => JsxRuntime.jsx(StockTransferFormActions.make, {})
    }),
    propState: [
      formState,
      match[1]
    ]
  });
}

let make = React.memo(StockTransferCreatePage);

export {
  make,
}
/* make Not a pure module */
